import script from "./HrSettingSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSettingSwitch.vue?vue&type=script&setup=true&lang=js"

import "./HrSettingSwitch.vue?vue&type=style&index=0&id=e61630ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e61630ec"]])

export default __exports__